module.exports = __webpack_public_path__ + "media/images/top/icon/white/ico_question-bb8d3f1577c1d133f63dcfd74fa24b05.svg";